import { priceFactory } from 'factories';
import { Entry } from 'types';

export function entryFactory(data: any = {}): Entry {
  const {
    product,
    priceWithDistributedDiscountPrice,
    unitPriceWithDistributedDiscountPrice,
    promotionBasePrice,
    totalPrice,
    basePrice,
    hasFreeBag,
    commissionPercentage,
    commissionValue,
    quantity,
    entryNumber,
  } = data ?? {};

  return {
    commissionPercentage: commissionPercentage ?? 0,
    commissionValue: priceFactory(commissionValue),
    entryNumber: entryNumber ?? 0,
    quantity: quantity ?? 0,
    product: {
      brandCode: product?.brandCode ?? '',
      ean: product?.ean ?? '',
      image: product?.image ?? '',
      name: product?.name ?? '',
      size: product?.size ?? '',
      code: product?.code ?? '',
      legacySKU: product?.legacySKU ?? '',
    },
    priceWithDistributedDiscountPrice: priceFactory(
      priceWithDistributedDiscountPrice
    ),
    unitPriceWithDistributedDiscountPrice: priceFactory(
      unitPriceWithDistributedDiscountPrice
    ),
    promotionBasePrice: priceFactory(promotionBasePrice),
    totalPrice: priceFactory(totalPrice),
    basePrice: priceFactory(basePrice),
    hasFreeBag: hasFreeBag ?? false,
  };
}
